/**
 * Texto da mensagem para exibir no chat: não repete URL/nome de arquivo da mídia.
 */
export default function getMessageBodyForDisplay(message) {
  const raw = message.body;
  if (raw === null || raw === undefined || String(raw).trim() === "") {
    return "";
  }
  const body = String(raw).trim();
  if (!message.mediaUrl) return raw;
  const mediaUrl = String(message.mediaUrl).trim();
  if (body === mediaUrl) return "";
  if (/^https?:\/\//i.test(body)) {
    try {
      if (new URL(body).pathname === new URL(mediaUrl).pathname) return "";
    } catch {
      /* ignore */
    }
  }
  if (
    !body.includes(" ") &&
    !body.includes("\n") &&
    body.length < 260 &&
    mediaUrl.endsWith(body)
  ) {
    return "";
  }
  return raw;
}
